/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useEffect, useRef, useState } from 'preact/hooks'
import { trapFocus, removeTrapFocus } from 'libs/accessibility'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import clsx from 'clsx'
import { map } from 'helpers/utils'
import { selectAll } from 'helpers/dom'
import { filters, activeFilters, setActiveFilters } from 'snippets/plp-native/@store'
import PlpNativeFilterList from 'snippets/plp-native/plp-native-filter-items/plp-native-filter-list'
import PlpNativeFilterApply from 'snippets/plp-native/plp-native-filter/plp-native-filter-apply'
import Icon from 'snippets/icon/icon'

function PlpNativeFilterSlideout({ openFilterRef, isMobile, isDesktop, countFilterSelected }) {
  const filterSlideOutWrapRef = useRef()
  const filtersRef = useRef({})
  const [tabIndex, setTabIndex] = useState(-1)
  const [localSelected, setLocalSelected] = useState([])

  const handleKeyUpMobile = (e) => {
    if (e.key !== 'Escape' || e.keyCode !== 27) return

    setActiveFilters()
    if (isMobile) removeTrapFocus(openFilterRef.current)
  }

  useEffect(() => {
    if (activeFilters.value) {
      const accordionsContent = selectAll('.js-accordion-description', filterSlideOutWrapRef.current)

      map(disableBodyScroll, [filtersRef.current, ...accordionsContent])
    } else {
      clearAllBodyScrollLocks()
    }

    setTabIndex(activeFilters.value ? 0 : -1)
    activeFilters.value && trapFocus(filterSlideOutWrapRef.current)
  }, [activeFilters.value])

  return (
    <>
      <div
        ref={filterSlideOutWrapRef}
        role="dialog"
        aria-modal="true"
        aria-label="Modal filter"
        tabIndex={tabIndex}
        onKeyUp={(e) => handleKeyUpMobile(e)}
        className={clsx(
          'fixed inset-0 left-0 z-50 h-full w-full max-w-[328px] -translate-x-full bg-white shadow-none outline-none outline-0 transition-transform duration-300 md:max-w-[357px]',
          {
            '!translate-x-0': activeFilters.value
          }
        )}
      >
        <div className="flex items-center justify-between p-5 border-b border-neutral-900">
          <p className="text-xs font-extrabold uppercase text-neutral-900 md:text-sm">{translate.collection.filters}</p>
          <button type="button" aria-label="close filter" onClick={() => setActiveFilters()}>
            <Icon name="icon-close-outline" className="size-4 text-neutral-900" />
          </button>
        </div>
        <div
          className="accordion-filter-collection h-[calc(100%_-_140px)] overflow-y-auto overflow-x-hidden px-5"
          ref={filtersRef}
        >
          {filters.value?.length > 0 ? (
            <PlpNativeFilterList isDesktop={isDesktop} setLocalSelected={setLocalSelected} />
          ) : (
            <p className="p-6">{translate.collection.noOptionFilter}</p>
          )}
        </div>
        <PlpNativeFilterApply localSelected={localSelected} countFilterSelected={countFilterSelected} />
      </div>
      <button
        type="button"
        aria-label="Close filter"
        onClick={() => setActiveFilters()}
        className={clsx([
          'fixed inset-0 z-40 bg-dark-overlay transition-opacity duration-300 ease-in-out',
          activeFilters.value ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
        ])}
      />
    </>
  )
}

export default PlpNativeFilterSlideout
